"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.onInitialClientRender = exports.wrapRootElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _createStore = _interopRequireDefault(require("./.tmp/createStore"));

var _constants = require("./constants");

var wrapRootElement = function wrapRootElement(_ref) {
  var element = _ref.element;
  var store = (0, _createStore["default"])(window[_constants.GLOBAL_KEY]);
  return _react["default"].createElement(_reactRedux.Provider, {
    store: store
  }, element);
};

exports.wrapRootElement = wrapRootElement;

var onInitialClientRender = function onInitialClientRender() {
  if (process.env.BUILD_STAGE !== 'build-javascript') {
    return;
  } // Remove the server-side injected state.


  var preloadedStateEl = document.getElementById(_constants.ELEMENT_ID);

  if (preloadedStateEl) {
    preloadedStateEl.parentNode.removeChild(preloadedStateEl);
  }
};

exports.onInitialClientRender = onInitialClientRender;